import i18n from '@/utils/i18n';
import React from 'react';
import {
  ActionSheet,
  Button,
  Icons,
  Typography,
  XStack,
  YStack,
} from '@usepepper/sprout-kit-ui';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const ICON_SIZE = 40;

interface LocationPermissionPrimerProps {
  onContinue: () => void;
  onDismiss: () => void;
  open: boolean;
}

export const LocationPermissionPrimer: React.FC<
  LocationPermissionPrimerProps
> = ({ onContinue, onDismiss, open }) => {
  const insets = useSafeAreaInsets();
  const continueLabel = i18n.t('sales_portal.location_permission.continue');

  return (
    <ActionSheet
      backdrop="blur"
      onOpenChange={(next) => {
        if (!next) {
          onDismiss();
        }
      }}
      open={open}
      size="fit"
    >
      <ActionSheet.Header
        alignItems="flex-start"
        flexDirection="column"
        gap="$16"
      >
        <XStack justifyContent="center" width="100%">
          <Icons.MapPin color="$iconPrimary" size={ICON_SIZE} />
        </XStack>
        <ActionSheet.Title
          accessibilityRole="header"
          color="$textPrimary"
          fontSize="$xl"
          fontWeight="$medium"
        >
          {i18n.t('sales_portal.location_permission.title')}
        </ActionSheet.Title>
      </ActionSheet.Header>
      <ActionSheet.Body>
        <YStack alignItems="flex-start" gap="$16" paddingBottom={insets.bottom}>
          <Typography color="$textSecondary" variant="body">
            {i18n.t('sales_portal.location_permission.body')}
          </Typography>
          <Button
            aria-label={continueLabel}
            onPress={onContinue}
            size="$lg"
            variant="primary"
            width="100%"
          >
            {continueLabel}
          </Button>
        </YStack>
      </ActionSheet.Body>
    </ActionSheet>
  );
};
